export default [
  {
    path: 'productos',
    name: 'empresa.productosLayout',
    meta: { modulo: 'productos' },

    component: () => import('@/views/empresa/productos/ProductosEmpresaLayout.vue'),
    redirect: { name: 'empresa.productosHome' },

    children: [
      {
        path: '',
        name: 'empresa.productosHome',
        component: () => import('@/views/empresa/productos/ProductosEmpresaHome.vue'),
        meta: {
          permiso: 'crear_producto'
        },
        redirect: { name: 'empresa.productosListado' },
        children: [
          {
            path: '', // ← listado por defecto en /productos
            name: 'empresa.productosListado',
            component: () => import('@/views/empresa/productos/ProductosEmpresaListado.vue'),
          },
          {
            path: 'precios',
            name: 'empresa.productos.gestionPrecios',
            component: () => import('@/views/empresa/productos/GestionListadoPrecios.vue'),
          },
          {
            path: 'centro-de-carga',
            name: 'empresa.productos.centroCarga',
            component: () => import('@/views/empresa/productos/carga/ProductosCentroCarga.vue'),
          },
          {
            path: 'centro-de-carga/:id',
            name: 'empresa.productos.cargaMesa',
            component: () => import('@/views/empresa/productos/carga/ProductosCargaMesa.vue'),
          },
          {
            path: 'fotos',
            name: 'empresa.productos.imagenesCarpeta',
            component: () => import('@/views/empresa/productos/ProductosImagenesCarpeta.vue'),
          },
          {
            path: 'control-de-carga',
            name: 'empresa.productos.controlCarga',
            component: () => import('@/views/empresa/productos/ProductosControlCarga.vue'),
          },
          {
            path: 'alta-masiva',
            name: 'empresa.productos.masivo.alta',
            component: () => import('@/views/empresa/productos/ProductosAltaMasiva.vue'),
          },
          {
            path: 'lista-precios',
            name: 'empresa.productos.listaPrecios',
            component: () => import('@/views/empresa/productos/ProductosEdicionExcel.vue'),
          },
          {
            path: 'categorias',
            name: 'empresa.productosCategorias',
            component: () => import('@/views/empresa/productos/categorias/ProductosEmpresaCategorias.vue'),
            redirect: { name: 'empresa.productosCategorias.unificar' },
            children: [
              {
                path: '',
                name: 'empresa.productosCategorias.unificar',
                component: () => import('@/views/empresa/productos/categorias/ProductoCategoriasTree.vue'),
              },
            ],
          },
        ],
      },



      // {
      //   path: 'registrar',
      //   name: 'empresa.productosRegistrarHome',
      //   component: () => import('@/views/empresa/productos/registrar/ProductoEmpresaRegistrarHome.vue'),
      //   children: [
      //     {
      //       path: '',
      //       name: 'empresa.productosRegistrar.tipoRegistro',
      //       component: () => import('@/views/empresa/productos/registrar/ProductoEmpresaRegistrarTipo.vue'),
      //     },
      //     {
      //       path: 'buscar',
      //       name: 'empresa.productosRegistrar.buscar',
      //       component: () => import('@/views/empresa/productos/registrar/ProductoEmpresaRegistrarBuscar.vue'),
      //     },
      //     {
      //       path: 'catalogo',
      //       name: 'empresa.productosRegistrar.catalogo',
      //       component: () => import('@/views/empresa/productos/registrar/ProductoEmpresaRegistrar.vue'),
      //     },
      //     {
      //       path: 'nuevo',
      //       name: 'empresa.productosRegistrar.nuevo',
      //       component: () => import('@/views/empresa/productos/registrar/ProductoEmpresaRegistrarNuevo.vue'),
      //     }
      //   ],
      // },
    ],
  },

  {
    path: 'productos/:id_producto',
    name: 'empresa.producto.item',
    meta: { modulo: 'productos', permiso: 'crear_producto' },


    component: () => import('@/views/empresa/productos/layout/ProductoEmpresaLayout.vue'),
    redirect: { name: 'empresa.producto.detalle' }, // 👈 redirección
    children: [
      {
        path: 'detalles',
        name: 'empresa.producto.detalle',
        meta: { modulo: 'productos', permiso: 'crear_producto' },

        component: () => import('@/views/empresa/productos/ProductoEmpresaUpdate.vue'),
      },
      {
        path: 'presentaciones',
        name: 'empresa.producto.presentaciones',
        meta: { modulo: 'productos', permiso: 'crear_producto' },
        component: () => import('@/views/empresa/productos/ProductoPresentacionesView.vue'),
      },
      {
        path: 'proveedores',
        name: 'empresa.producto.proveedores',
        meta: { modulo: 'productos', permiso: 'crear_producto' },
        component: () => import('@/views/empresa/productos/ProductoEmpresaProveedores.vue'),
      },
      {
        path: 'historial',
        name: 'empresa.producto.historial',
        meta: { modulo: 'productos', permiso: 'crear_producto' },
        component: () => import('@/views/empresa/productos/ProductoEmpresaHistorial.vue'),
      },
      {
        path: 'ayuda',
        name: 'empresa.producto.ayuda',
        meta: { modulo: 'productos', permiso: 'crear_producto' },
        component: () => import('@/views/empresa/productos/ProductoEmpresaAyuda.vue'),
      },
      {
        path: 'sucursales',
        name: 'empresa.producto.sucursales',
        meta: { modulo: 'productos', permiso: 'crear_producto' },

        component: () => import('@/views/empresa/productos/ProductoEmpresaSucursales.vue')
      },
    ],
    meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: false },
  },
  {
    path: 'productos/registrar',
    meta: { modulo: 'productos', permiso: 'crear_producto' },


    name: 'empresa.productos.registrar.layout',
    component: () => import('@/views/empresa/productos/layout/ProductoEmpresaRegistrarLayout.vue'),
    redirect: { name: 'empresa.productos.registrar.selector' },
    children: [
      {
        path: '',
        name: 'empresa.productos.registrar.selector',
        component: () => import('@/views/empresa/productos/registrar/ProductoEmpresaRegistrarSelector.vue'),
        meta: { step: 1, title: 'Seleccionar tipo de producto' },
      },
      {
        path: 'catalogo',
        name: 'empresa.productos.registrar.catalogo',
        component: () => import('@/views/empresa/productos/registrar/ProductoEmpresaRegistrarWizard.vue'),
        props: { esElaboracionPropia: false },
        meta: { title: 'Registrar producto de catálogo' },
      },
      {
        path: 'produccion',
        name: 'empresa.productos.registrar.produccion',
        component: () => import('@/views/empresa/productos/registrar/ProductoEmpresaRegistrarWizard.vue'),
        props: { esElaboracionPropia: true },
        meta: { title: 'Registrar producto de producción' },
      }
    ],

  }

]
